const STORAGE_KEY = 'sideBarPosition';

export const sideBarPosition = {
  get(): any {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data === null) {
      return data;
    }
    return JSON.parse(data);
  },
  set(position: any): void {
    const data = JSON.stringify(position);
    localStorage.setItem(STORAGE_KEY, data);
  },
  getDefault(): any {
    return 'top';
  },
};
